import React from 'react';
import cn from 'classnames';
import style from './image.mod.scss';
import { GatsbyImage } from 'gatsby-plugin-image';

const Image = ({ image, borderRadius = false }) => {
  const classes = cn(style.image, {
    [style[`image__rounded`]]: borderRadius,
  });

  return (
    <>
      <div className={classes}>
        <GatsbyImage image={image.gatsbyImageData} alt={image.alt || ''} />
      </div>
    </>
  );
};

export default Image;
